import React from "react";
import { ButtonLink } from "../..";
import PropTypes from "prop-types";

export const SubscriptionButton = ({text, type}) => {
    const buttonClick = () => {
        const str = `subscription-after-auth=${type};domain=zaycev.net;max-age=3600`;
        document.cookie = str;
    };
    const urlForSubscribe = 'https://zaycev.net/profile/index.php';

    return <ButtonLink text={text} href={urlForSubscribe} onClick={buttonClick}></ButtonLink>
}

SubscriptionButton.propTypes = {
    text: PropTypes.string,
    type: PropTypes.number
}